import { Image, Container, Row, Col } from 'react-bootstrap';
import "./Services.css";
import "./Contact.css";
import Img from '../Img/Contact/Contact Banner.jpg';
import Phone from '../Img/Contact Icons/call.png';
import Mail from '../Img/Contact Icons/mail.png';
import Map from '../Img/Contact Icons/map.png';
import Whatsapp from '../Img/Contact Icons/whatsapp.png';

function Contact() {
  return (
    <>
      <Image className="fade-in responsive-img" src={Img} height={500} width="100%" fluid />

      <Container>
        {/* Header */}
        <div className="contact-hero">
          <span className="contact-hero__eyebrow">Get In Touch</span>
          <h1 className="contact-hero__title">Let's Move Your Cargo Together</h1>
          <p className="contact-hero__subtitle">
            Whether you need a quick freight quote, a warehousing partner, or a complete
            logistics solution — MMOPL's team is ready to help. Reach out today and we'll
            respond promptly with a tailored plan.
          </p>
        </div>

        {/* Contact cards + Map */}
        <Row className="gy-4 align-items-stretch mb-5">
          {/* Left — info cards */}
          <Col lg={5} md={12}>

            <h2 className="contact-section-title">Reach Us Directly</h2>

            {/* Address */}
            <div className="contact-card">
              <div className="contact-card__icon">
                <img src={Map} alt="Address" />
              </div>
              <div className="contact-card__body">
                <p className="contact-card__label">Head Office</p>
                <p className="contact-card__value">
                  A-173, Second Floor, Road No.4, Street No.10,<br />
                  Mahipalpur, New Delhi - 110037
                </p>
                <p className="contact-card__hint">Mon – Sat, 9:30 AM – 6:30 PM IST</p>
              </div>
            </div>

            {/* Phone */}
            <a href="tel:01142198316" className="contact-card">
              <div className="contact-card__icon">
                <img src={Phone} alt="Phone" />
              </div>
              <div className="contact-card__body">
                <p className="contact-card__label">Landline</p>
                <p className="contact-card__value">
                  011-42198316 &nbsp;/&nbsp; 011-42198317
                </p>
                <p className="contact-card__hint">Speak to our logistics desk</p>
              </div>
            </a>

            {/* Mobile */}
            <a href="tel:+919717295703" className="contact-card">
              <div className="contact-card__icon">
                <img src={Phone} alt="Mobile" />
              </div>
              <div className="contact-card__body">
                <p className="contact-card__label">Mobile — Delhi Office</p>
                <p className="contact-card__value">+91-9717295703</p>
                <p className="contact-card__hint">Sandeep — Business Head</p>
              </div>
            </a>

            {/* WhatsApp */}
            <a
              href="https://wa.me/919717295703"
              target="_blank"
              rel="noopener noreferrer"
              className="contact-card"
            >
              <div className="contact-card__icon">
                <img src={Whatsapp} alt="WhatsApp" />
              </div>
              <div className="contact-card__body">
                <p className="contact-card__label">WhatsApp</p>
                <p className="contact-card__value">+91-9717295703</p>
                <p className="contact-card__hint">Quick quotes & shipment updates</p>
              </div>
            </a>

            {/* Email */}
            <a href="mailto:info@mmolpl.com" className="contact-card">
              <div className="contact-card__icon">
                <img src={Mail} alt="Email" />
              </div>
              <div className="contact-card__body">
                <p className="contact-card__label">Email</p>
                <p className="contact-card__value">info@mmolpl.com</p>
                <p className="contact-card__hint">Replies within 24 hours</p>
              </div>
            </a>

          </Col>

          {/* Right — map */}
          <Col lg={7} md={12}>
            <h2 className="contact-section-title">Find Us</h2>
            <div className="contact-map-panel">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3504.0!2d77.1247!3d28.5436!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2sMulti%20Modal%20Overseas!5e0!3m2!1sen!2sin!4v0000000000000"
                title="MMOPL — Mahipalpur, New Delhi"
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </Col>
        </Row>

        {/* Bottom CTA */}
        <div className="contact-cta">
          <h3>Ready to Ship? Let's Talk.</h3>
          <p>
            Share your cargo details, route and timeline — we'll come back with a
            tailored logistics plan and competitive quote.
          </p>
          <a
            href="https://wa.me/919717295703"
            target="_blank"
            rel="noopener noreferrer"
            className="cta-btn"
          >
            Chat on WhatsApp
          </a>
        </div>
      </Container>
    </>
  );
}

export default Contact;